import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../../lib/utils.js';

export type SplitWorkbenchAsidePosition = 'start' | 'end';

export interface SplitWorkbenchLayoutProps extends HTMLAttributes<HTMLDivElement> {
  asideWidth?: number;
  asidePosition?: SplitWorkbenchAsidePosition;
  aside: ReactNode;
  children: ReactNode;
}

/** Master/detail workbench grid — protótipo Caixa / PDV split. */
export function SplitWorkbenchLayout({
  asideWidth = 340,
  asidePosition = 'start',
  aside,
  children,
  className,
  style,
  ...props
}: SplitWorkbenchLayoutProps) {
  const layoutStyle = {
    ...style,
    '--split-workbench-aside-width': `${asideWidth}px`,
  } as CSSProperties;

  return (
    <div
      className={cn(
        'split-workbench',
        asidePosition === 'end' ? 'split-workbench--aside-end' : 'split-workbench--aside-start',
        className,
      )}
      style={layoutStyle}
      {...props}
    >
      {asidePosition === 'start' ? (
        <>
          <aside className="split-workbench-aside">{aside}</aside>
          <section className="split-workbench-main">{children}</section>
        </>
      ) : (
        <>
          <section className="split-workbench-main">{children}</section>
          <aside className="split-workbench-aside">{aside}</aside>
        </>
      )}
    </div>
  );
}
